<template>
  <v-card elevation="0" flat tile>
    <v-card-text>
      <v-row justify="space-around">
        <v-col cols="12" md="12">
          <!-- Active -->
          <v-checkbox
            color="secondary"
            v-model="vastModel.active"
            :label="$t('common:active')"
          />

          <!-- Vast Company -->
          <v-select
            :items="vastList"
            :disabled="!vastModel.active"
            item-text="translatedName"
            item-value="id"
            :menu-props="{bottom: true, offsetY: true}"
            v-model="vastModel.vastCompany"
            outlined
            clearable
            :label="$t('display/elevator:edit.labels.vast-tab.vast-company')"
            :rules="[ vastModel.active ? ruleRequired($t('utils:rules.required')) : true]"
          />

          <!-- VAST-ID -->
          <v-text-field
            outlined
            :disabled="!vastModel.active"
            v-model="vastModel.vastId"
            :label="$t('display/elevator:edit.labels.vast-tab.vast-id')"
            :rules="[ vastModel.active ? ruleRequired($t('utils:rules.required')) : true]"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import EnumUtils from '@/modules/core/services/enum-utils';
import {ruleRequired} from '@/modules/core/services/rules';

export default {
  name: "VastTab",
  data() {
    return {
      vastList: [],
      vastModel: {
        active: false,
        vastId: '',
        vastCompany: ''
      }
    }
  },
  watch: {
    vastModel: {
      handler() {
        this.$store.commit('display/elevatorForm/updateVast', this.vastModel);
      },
      deep: true
    },
  },
  methods: {
    ruleRequired,
    loadContracts() {
      EnumUtils.loadEnum('vastList', 'display/elevator', 'vastList',
        (response) => {
          this.vastList = response;
        }
      );
    },
    setVast() {
      let vast = this.$store.state.display.elevatorForm.elevator.vastList;

      if (vast && vast.length > 0) {
        // right now we have just one VAST for elevator
        this.vastModel = vast[0];
      }
    }
  },
  created() {
    this.loadContracts();
    this.setVast();
  }
}
</script>

<style scoped>
</style>
